import { getGridStringOperators, GridFilterItem, GridColDef } from "@mui/x-data-grid";

export function createBooleanFilterOperators(fieldName: string) {
  return getGridStringOperators().map((operator) => ({
    ...operator,
    getApplyFilterFn: (filterItem: GridFilterItem, column: GridColDef) => {
      if (!operator.getApplyFilterFn) return null;
      const baseFilterFn = operator.getApplyFilterFn(filterItem, column);
      if (!baseFilterFn) return null;
      return (params: any) => {
        const rawValue = params.row[fieldName];
        const displayValue = rawValue == 1 ? "是" : "否";
        const filterValue = filterItem.value;

        if (filterValue === "是" || filterValue === "否") {
          return displayValue === filterValue;
        }
        if (filterValue === "1" || filterValue === "0") {
          return rawValue === parseInt(filterValue);
        }

        return baseFilterFn({ ...params, value: displayValue });
      };
    },
  }));
}

